/**
 * Smooth Scroll Implementation
 * Este script implementa scroll suave para links internos
 */

export function initSmoothScroll() {
  // Seleciona todos os links que começam com # ou contêm #
  const links = document.querySelectorAll('a[href^="#"], a[href*="#"]');

  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      // Verifica se o link é para um elemento na mesma página
      const href = this.getAttribute("href");
      if (href.startsWith("#") && href.length > 1) {
        e.preventDefault();

        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Obtém a posição do elemento alvo
          const targetPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset;
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;

          // Configuração da animação
          const duration = 800; // duração em milissegundos
          let start = null;

          // Função de animação
          function animation(currentTime) {
            if (start === null) start = currentTime;
            const timeElapsed = currentTime - start;
            const progress = Math.min(timeElapsed / duration, 1);

            // Função de easing (suavização)
            const easeInOutCubic = (progress) => {
              return progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            };

            window.scrollTo(
              0,
              startPosition + distance * easeInOutCubic(progress)
            );

            if (timeElapsed < duration) {
              requestAnimationFrame(animation);
            }
          }

          requestAnimationFrame(animation);
        }
      }
    });
  });
}
